module.exports = __webpack_public_path__ + "static/media/verao-partitura-0.2409cc62.png";